import React, {Component as RawComponent} from 'react'
import autoBind from './autoBind'

export default React

export class Component extends RawComponent {
  constructor(props) {
    super(props)
    autoBind(this)
  }
}



// WEBPACK FOOTER //
// ./src/lib/react.js